import { render, staticRenderFns } from "./employeeReviews.vue?vue&type=template&id=22a354f8"
import script from "./employeeReviews.vue?vue&type=script&lang=js"
export * from "./employeeReviews.vue?vue&type=script&lang=js"
import style0 from "./employeeReviews.vue?vue&type=style&index=0&id=22a354f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports